import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Feather, ChevronRight, MoonStar, Heart, PenLine, Pencil } from "lucide-react";

export const fmtPubDate = (iso) =>
  new Date(iso).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" });

export default function OltreLeCarte() {
  const [posts, setPosts] = useState(null);
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";

  useEffect(() => {
    api.get("/posts").then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 lg:px-8 py-14 sm:py-20" data-testid="oltre-le-carte-page">
      <div className="text-center mb-12">
        <span className="inline-flex w-14 h-14 rounded-full border border-amber-500/40 items-center justify-center mb-5">
          <Feather className="w-6 h-6 text-amber-400" />
        </span>
        <p className="eyebrow">Editoriale</p>
        <h1 className="font-display text-4xl sm:text-5xl gold-text mt-3" data-testid="oltre-title">Oltre le Carte</h1>
        <p className="text-purple-200/70 mt-4" data-testid="oltre-subtitle">
          Pensieri, curiosità e storie oltre il mondo delle carte.
        </p>
      </div>

      {isAdmin && (
        <div className="mystic-card p-4 mb-8 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="oltre-admin-bar">
          <p className="text-xs text-purple-300/60 flex-1">Area amministratrice: crea e gestisci i contenuti editoriali.</p>
          <Link
            to="/admin?tab=oltre&new=1"
            data-testid="oltre-new-post-btn"
            className="gold-btn inline-flex items-center justify-center gap-2 px-5 py-2.5 text-xs shrink-0"
          >
            <PenLine className="w-4 h-4" /> Scrivi un post
          </Link>
        </div>
      )}

      {posts === null ? (
        <p className="text-center text-purple-300/50 text-sm" data-testid="oltre-loading">Caricamento…</p>
      ) : posts.length === 0 ? (
        <div className="mystic-card p-10 text-center" data-testid="oltre-empty">
          <MoonStar className="w-8 h-8 text-amber-400/60 mx-auto mb-4" />
          <p className="text-purple-200/70">I primi contenuti arriveranno presto.</p>
        </div>
      ) : (
        <div className="space-y-3" data-testid="oltre-list">
          {posts.map((p) => (
            <div key={p.id} className="flex items-center gap-2">
              <Link
                to={`/oltre-le-carte/${p.id}`}
                data-testid={`oltre-post-${p.id}`}
                className="mystic-card px-6 py-5 flex items-center gap-4 group hover:border-amber-500/50 transition-colors duration-300 flex-1 min-w-0"
              >
                <Feather className="w-4 h-4 text-amber-400/70 shrink-0" />
                <div className="flex-1 min-w-0">
                  <h2 className="font-display text-xl text-amber-100 group-hover:text-amber-200 transition-colors truncate">{p.title}</h2>
                  <p className="text-xs text-purple-300/50 mt-1">{fmtPubDate(p.published_at)}</p>
                </div>
                {(p.likes ?? 0) > 0 && (
                  <span className="flex items-center gap-1.5 text-xs text-purple-300/60 shrink-0" data-testid={`oltre-post-likes-${p.id}`}>
                    <Heart className="w-3.5 h-3.5 text-amber-400/70 fill-amber-400/30" /> {p.likes}
                  </span>
                )}
                <ChevronRight className="w-4 h-4 text-purple-300/50 group-hover:text-amber-300 transition-colors shrink-0" />
              </Link>
              {isAdmin && (
                <Link
                  to={`/admin?tab=oltre&edit=${p.id}`}
                  data-testid={`oltre-edit-${p.id}`}
                  className="mystic-card p-3.5 text-purple-300/70 hover:text-amber-300 hover:border-amber-500/50 transition-colors shrink-0"
                  title="Modifica questo post"
                >
                  <Pencil className="w-4 h-4" />
                </Link>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
